import { defineMessages } from 'react-intl';

const ID_PREFIX = 'FeaturesHighlightWpl.';

export const messages = defineMessages({
  heading: {
    id: `${ID_PREFIX}heading`,
    defaultMessage: `The is a default heading`
  },
  cardLabel1: {
    id: `${ID_PREFIX}label1`,
    defaultMessage: `Card Label 1`
  },
  cardLabel2: {
    id: `${ID_PREFIX}label2`,
    defaultMessage: `Card Label 2`
  },
  cardLabel3: {
    id: `${ID_PREFIX}label3`,
    defaultMessage: `Card Label 3`
  },
  cardCategory1: {
    id: `${ID_PREFIX}categoryLabel1`,
    defaultMessage: `Card Category 1`
  },
  cardCategory2: {
    id: `${ID_PREFIX}categoryLabel2`,
    defaultMessage: `Card Category 2`
  },
  cardCategory3: {
    id: `${ID_PREFIX}categoryLabel3`,
    defaultMessage: `Card Category 3`
  },
  cardTitle1: {
    id: `${ID_PREFIX}cardTitle1`,
    defaultMessage: `Card Title 1`
  },
  cardTitle2: {
    id: `${ID_PREFIX}cardTitle2`,
    defaultMessage: `Card Title 2`
  },
  cardTitle3: {
    id: `${ID_PREFIX}cardTitle3`,
    defaultMessage: `Card Title 3`
  },
  cardDescription1: {
    id: `${ID_PREFIX}cardDescription1`,
    defaultMessage: `Feature 01 description lorem ipsum dolor amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.`
  },
  cardDescription2: {
    id: `${ID_PREFIX}cardDescription2`,
    defaultMessage: `Feature 02 description lorem ipsum dolor amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.`
  },
  cardDescription3: {
    id: `${ID_PREFIX}cardDescription3`,
    defaultMessage: `Feature 03 description lorem ipsum dolor amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.`
  },
  altTextImage1: {
    id: `${ID_PREFIX}altTextImage1`,
    defaultMessage: `This is default alternative text for Image 1`
  },
  altTextImage2: {
    id: `${ID_PREFIX}altTextImage2`,
    defaultMessage: `This is default alternative text for Image 2`
  },
  altTextImage3: {
    id: `${ID_PREFIX}altTextImage3`,
    defaultMessage: `This is default alternative text for Image 3`
  },
  embeddedVideosError: {
    id: `${ID_PREFIX}embeddedVideosError`,
    defaultMessage: `Sorry, your browser doesn't support embedded videos.`
  }
});
